
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/dora",
      function () {
        return require("private-next-pages/compliance/dora.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/dora"])
      });
    }
  